import "./error.scss";
import "../../assets/scss/main.scss";
import React from "react";
import { Box, Button, Card, ThemeProvider, Typography } from "@mui/material";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import theme from "../../assets/theme/theme";
import { GLOBALSETTINGS } from "../../data/constants";
import { GLOBALMESSAGES } from "../../constants/messages";
const NotAuthorized = ({isAccessMenu}) => {
  return (
    <ThemeProvider theme={theme}>
      <>
        <Card variant="outlined" sx={{ height: "330px" }} className="card p-4 text-center">
          <Typography variant="h1" className="error-sub-title">
            OOPS! You are not authorized to view this page.
          </Typography>

          <Typography mt={2} variant="body1" className="page-error-text">
            {GLOBALMESSAGES.NOT_AUTHORIZED}
          </Typography>
          <div className="text-center">
            <Box className="action-container" mt={2}>
              {(isAccessMenu &&
              <Button
                onClick={() => (window.location.href = GLOBALSETTINGS.DEFAULT_PAGE)}
                variant="contained"
                startIcon={<HomeRoundedIcon />}
              >
                Back to Dashboard
              </Button>
              )}
            </Box>
          </div>
        </Card>
      </>
    </ThemeProvider>
  );
};

export default NotAuthorized;
